import { Flame, Handshake, Heart, Shield, Sparkles, Target, Trophy, Users } from 'lucide-react'
import type { ValueIcon as ValueIconName } from '@/lib/types'

/**
 * The CMS `values.icon` field is a select constrained to exactly these names,
 * so an editor can never pick an icon the bundle does not contain.
 */
const ICONS = {
  shield: Shield,
  flame: Flame,
  users: Users,
  heart: Heart,
  trophy: Trophy,
  target: Target,
  handshake: Handshake,
  sparkles: Sparkles,
} as const

export const VALUE_ICON_NAMES = Object.keys(ICONS) as ValueIconName[]

export function ValueIcon({
  name,
  className,
}: {
  name: ValueIconName | '' | undefined
  className?: string
}) {
  const Icon = name && name in ICONS ? ICONS[name] : Shield
  return <Icon className={className} aria-hidden />
}
